export default {
  it: {
    h2: 'Clienti',
  },
  en: {
    h2: 'Our Partners',
  },
};
